import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { IconReceiptCheck, IconPlus } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { ROUTES } from "@constants/routes";

export default function AnnualProcurementPlanHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const navigateToCreateProcurementPlan = () => {
    navigate(ROUTES.CREATE);
  };

  const breadcrumbs = [
    {
      icon: <IconReceiptCheck fill="dark" size="20" />,
    },
    {
      label: t("PROCUREMENT_ANNUAL_PLAN.HEADER.HEADING"),
    },
  ];

  const headerText = {
    header: t("PROCUREMENT_ANNUAL_PLAN.HEADER.HEADING"),
  };

  const actions = [
    <Button
      type="info"
      fill="fill"
      size="sm"
      onClick={navigateToCreateProcurementPlan}
    >
      <IconPlus size={20} fill="light" />
      {t("PROCUREMENT_ANNUAL_PLAN.HEADER.ADD_BUTTON_TEXT")}
    </Button>,
  ];

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      actions={getAccess(roles, "PROCUREMENT_HR") ? actions : [<></>]}
    />
  );
}
